<template>
  <div>
    <div class="rp-file has-name is-fullwidth is-small">
      <label class="rp-file-label">
        <input
          class="rp-file-input"
          ref="files"
          type="file"
          v-bind:placeholder="inputData.placeholder"
          v-on:change="updateValue($event.target.value)"
        >
        <span class="rp-file-cta">
          <span class="rp-file-icon">
            <i class="fa fa-upload"></i>
          </span>
          <span class="rp-file-label">
            <span>
            {{ t.chooseFile }}
            </span>
          </span>
        </span>
        <span class="rp-file-name">
          {{ filenames ||  t.noFile}}
        </span>
      </label>
    </div>
    <div class="validation-text" v-if="status === true && errorStatus === ''">
      {{ t.pleaseChooseFile }}
    </div>
    <div class="validation-text" v-if="status === true && errorStatus === 'pleaseUploadAllowedFileType'">
      {{ t.pleaseUploadAllowedFileType }}: {{ formData.type }}
    </div>
    <div class="validation-text" v-if="status === true && errorStatus === 'pleaseUploadAllowedFileSize'">
      {{ t.pleaseUploadAllowedFileSize }} {{ bytesToSize(formData.size) }}
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'FileInput',
  props: {
    value: File,
    inputData: {
      type: Object,
      default: () => {
        return {
          id: 1,
          type: 'file',
          required: '0',
          placeholder: 'placeholder'
        }
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {
          size: 5000000,
          type: [
            'jpg',
            'png'
          ]
        }
      }
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          pleaseChooseFile: 'Please choose a file',
          pleaseUploadAllowedFileType: 'Please upload allowd file types',
          pleaseUploadAllowedFileSize: 'Please upload file size below',
          noFile: 'No file chosen',
          chooseFile: 'choose a file'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          pleaseChooseFile: 'กรุณาเลือกไฟล์',
          pleaseUploadAllowedFileType: 'กรุณาอัพโหลดไฟล์ประเภท',
          pleaseUploadAllowedFileSize: 'กรุณาอัพโหลดไฟล์ขนาดไม่เกิน',
          noFile: 'ไม่ได้เลือกไฟล์',
          chooseFile: 'เลือกไฟล์'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          pleaseChooseFile: 'Vui lòng chọn một tập tin',
          pleaseUploadAllowedFileType: 'Vui lòng chỉ tải loại tập tin hợp lệ',
          pleaseUploadAllowedFileSize: 'Vui lòng tải tập tin có độ lớn thấp hơn',
          noFile: 'Không tập tin nào được chọn',
          chooseFile: 'Chọn tập tin'
        }
      }
    }
  },
  data () {
    return {
      status: false,
      errorStatus: '',
      files: [],
      filenames: ''
    }
  },
  methods: {
    validateInput () {
      let result = true

      if (this.files.length < 1) {
        if (this.inputData.required === '1') {
          result = false
          this.status = true
        } else {
          result = true
          this.status = false
        }
      } else {
        result = true
        this.status = false
      }

      if (result === true && this.files.length > 0) {
        let fileExt = this.files[0].name.split('.')
        fileExt = fileExt[fileExt.length - 1]

        if (this.formData.type.indexOf(fileExt.toLowerCase()) < 0) {
          result = false
          this.status = true
          this.errorStatus = 'pleaseUploadAllowedFileType'
        } else if (this.files[0].size > this.formData.size) {
          result = false
          this.status = true
          this.errorStatus = 'pleaseUploadAllowedFileSize'
        }
      }

      return result
    },
    updateValue (value) {
      this.files = this.$refs.files.files

      if (value !== '' || value !== 'undefined') {
        let filename = value.split('\\')
        this.filenames = filename[filename.length - 1]
        this.validateInput()
      }
    },
    getFiles () {
      return this.files[0]
    },
    bytesToSize (bytes) {
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes == 0) return '0 Byte'
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    clearFile () {
      let input = this.$refs.files
      input.type = 'text'
      input.type = 'file'
      this.filenames = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.validation-text {
  color: red;
  font-size: 0.75em;
}
.rp-file {
  user-select: none;
  align-items: stretch;
  display: flex;
  justify-content: flex-start;
  position: relative;
  &.is-small{
    border-radius: 2px;
    font-size: 0.75em;
  }
  &.is-fullwidth .rp-file-label {
    width: 100%;
  }
}
.rp-file-label {
  user-select: none;
  align-items: stretch;
  display: flex;
  justify-content: flex-start;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}
.rp-file.has-name .rp-file-cta {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.rp-file-input {
  height: 0.01em;
  left: 0;
  outline: none;
  position: absolute;
  top: 0;
  width: 0.01em;
}
.rp-file-cta {
  background: whitesmoke;
  color: #4a4a4a;
}
.rp-file-cta, .rp-file-name {
  align-items: center;
  display: inline-flex;
  justify-content: flex-start;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  height: 2.25em;
  line-height: 2.3;
  padding-bottom: calc(0.375em - 1px);
  padding-top: calc(0.375em - 1px);
  vertical-align: top;
  border-color: #dbdbdb;
  font-size: 1em;
  padding-left: 1em;
  padding-right: 1em;
  white-space: nowrap;
}
.rp-file.is-fullwidth .rp-file-name {
  flex-grow: 1;
  max-width: none;
}
.rp-file.has-name .rp-file-name{
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.rp-file-name {
  border-style: solid;
  border-width: 1px 1px 1px 0;
  display: block;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  width: 10px;
}
.rp-file-icon {
  align-items: center;
  display: flex;
  height: 1em;
  justify-content: center;
  margin-right: 1em;
  width: 1em;
  .fa {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .rp-file {
    &.is-fullwidth .rp-file-label {
      width: calc(100% - 0.25em);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/FileInput.vue